import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
import { CompanyModel } from "./Company";
import { DropboxModel } from "./Dropbox";

export class TenantModel extends Model  {
    name: string = "";
    schema: string = "";
    db: string = "";
    website_label: string = "";
    api_secret: string|null;
    knowledge_website: string|null;
    company:CompanyModel|null;
    fields:any = {};
    
    constructor(data = null) {
        super();
        
        if(data) {
            this.createModel(data, {company: CompanyModel});
            
            for(let i in data.ppc_tenant_fields) {
                let fieldKey = data.ppc_tenant_fields[i].fieldkey;
                let obj = data.ppc_tenant_fields[i].data;
                
                if(fieldKey == "DROPBOX") {
                    obj = new DropboxModel(obj);
                } else {
                    obj = Object.assign({}, obj);    
                }
                this.fields[fieldKey] = obj
            }
            
            
        }
    }
    
    public addCompany() {
        let company:CompanyModel = new CompanyModel();
        
        return company;
        
    }
}